import { render, staticRenderFns } from "./productCheck4Factory.vue?vue&type=template&id=252f14ee"
import script from "./productCheck4Factory.vue?vue&type=script&lang=js"
export * from "./productCheck4Factory.vue?vue&type=script&lang=js"
import style0 from "./productCheck4Factory.vue?vue&type=style&index=0&id=252f14ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports